// extracted by mini-css-extract-plugin
export default {"updateArrow":"UpdateArrow_updateArrow__Jc4CR"};